package gr.tech.meetinggenie.models.meeting

import kotlinx.serialization.Serializable

@Serializable
data class WeeklySummaryDTO(
    var oneSentenceSummary: String = "",   // required
    var topPriorityNextWeek: String = ""   // required
)
